import { OverridedIcons } from '@websky/core';
import { Land, Takeoff, Cash, Checked, NotAvailable, Exchangeable, Refundable } from './Icons';

export const overrideIcons: OverridedIcons = {
	Land: () => Land,
	Takeoff: () => Takeoff,
	Paid: () => Cash,
	Included: () => Checked,
	NotIncluded: () => NotAvailable,
	Exchangeable: () => Exchangeable,
	Refundable: () => Refundable
};
